import { render, staticRenderFns } from "./RegisterPointSearchSuccess.vue?vue&type=template&id=16a64d75&"
import script from "./RegisterPointSearchSuccess.vue?vue&type=script&lang=js&"
export * from "./RegisterPointSearchSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports